<template>
    <tr>
        <td>
            {{row.bus_stop.stop.geo_point.name}}
        </td>
        <!-- <td>
            P:{{row.bus_stop.order}}-E:{{row.bus_stop.order_1}}-R:{{row.bus_stop.order_2}}
        </td> -->
        <td>
            {{row.count_adults}}
        </td>
        <td>
            {{row.count_children}}
        </td>
        <td>
            {{total_pax}}
        </td>
        <td>
            {{row.bus_stop.hora}}
        </td>
        
        <td style="width: 5%;">
            <b-dropdown
                dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                class="float-right"
            >
                <template v-slot:button-content>
                    <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item>
                    <div v-b-modal="'edit_stop_hour_' + row.bus_stop.id">
                        <i class="fa fa-pencil fa-fw"></i> Editar hora de paso
                    </div>
                    <edit-stop-hour :stop="row.bus_stop" />
                </b-dropdown-item>
            </b-dropdown>
        </td>
    </tr>
</template>


<script>
//import stopTimeModal from '../Booking/BookingModal/stopTimeModal';
import EditStopHour from '../Booking/Modal/EditStopHour'
import { mapGetters } from "vuex";

export default {
    components: {
        EditStopHour,
    },
    props: {
        row: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(['activeTab']),
        order() {
            return this.activeTab === 'Excursions' ? this.row.bus_stop.order_1 : this.row.bus_stop.order
        },
        total_pax() {
            return this.row.count_adults + this.row.count_children
        }
    }
}
</script>
